<template>
  <layout-with-sidebar>

    <HeaderComponent/>

    <div class=" ed-bg text-color" style="min-height:100vh">
      <div v-if="!loggedUser.is_completed" class="alert alert-danger" role="alert">
        Completa il tuo profilo per utilizzare l'applicazione.
      </div>
      <br>
      <h1 class="h3 mb-3 font-weight-normal text-color text-center">Il tuo Profilo</h1>
      <div>

        <!-- <b-form class=" custom-centered" > -->


        <b-form v-if="!isLoading">

          <div class="container text-left">

            <div class="form-group">
              <label>Ragione Sociale / Nome e Cognome </label>
              <input v-model="user_form.full_name" type="text" class="form-control" placeholder="">
            </div>
            <div class="form-group">
              <label>Indirizzo </label>
              <input v-model="user_form.address" type="text" class="form-control" placeholder="">
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Partita Iva / Codice Fiscale</label>
                <input v-model="user_form.fiscal_vat_code" type="" class="form-control" placeholder="">
              </div>

              <div class="form-group col-md-4">
                <label>Settore</label>
                <input v-model="user_form.sector" type="" class="form-control" placeholder="">
              </div>

              <div class="form-group col-md-4">
                <label>Telefono</label>
                <input v-model="user_form.phone" type="" class="form-control" placeholder="">
              </div>

            </div>


            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Provincia </label>
                <input v-model="user_form.city" type="" class="form-control" placeholder="">
              </div>
              <div class="form-group col-md-4">
                <label>Città</label>
                <input v-model="user_form.town" type="" class="form-control" placeholder="">
              </div>
              <div class="form-group col-md-4">
                <label>CAP</label>
                <input v-model="user_form.zip_code" type="" class="form-control" placeholder="">
              </div>
            </div>

            <b-button type="submit" class="btn btn-lg btn-success btn-block" variant="primary"
                      @click.prevent="modify()">Salva
            </b-button>
          </div>

        </b-form>
        <!-- <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->
        <p class="mt-4 mb-3 text-muted">Dati obbligatori.</p>
        <br>
        <br>
      </div>

    </div>

  </layout-with-sidebar>
</template>


<script>
import axios from "axios";

import LayoutWithSidebar from "@/components/layouts/LayoutWithSidebar";

import HeaderComponent from "../../components/HeaderComponent.vue";

export default {
  name: "UserSettings", //this is the name of the component
  components: {
    LayoutWithSidebar: LayoutWithSidebar,
    HeaderComponent: HeaderComponent
  },
  data: function () {
    return {
      isLoading: true,
      responseOk: false,
      errors: {},
      user: {},
      user_form: {
        full_name: "",
        fiscal_vat_code: "",
        city: "",
        phone: "",
        company_name: "",
        zip_code: "",
        region: "",
        username: "",
        email: "",
        town: "",
        address: "",
        sector: ""
      },
      show: true
    };
  },
  mounted: function () {
    this.getUser();
  },
  computed: {},
  methods: {
    getUser: function () {
      var $vm = this;
      axios
          .get(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.loggedUser.id
          )
          .then(function (response) {
            $vm.user = response.data;
            $vm.user_form.email = response.data.email;
            $vm.user_form.username = response.data.username;

            if (typeof response.data.full_name !== "undefined") {
              $vm.user_form.full_name = response.data.full_name;
            }
            if (typeof response.data.fiscal_vat_code !== "undefined") {
              $vm.user_form.fiscal_vat_code = response.data.fiscal_vat_code;
            }
            if (typeof response.data.city !== "undefined") {
              $vm.user_form.city = response.data.city;
            }
            if (typeof response.data.region !== "undefined") {
              $vm.user_form.region = response.data.region;
            }
            if (typeof response.data.zip_code !== "undefined") {
              $vm.user_form.zip_code = response.data.zip_code;
            }
            if (typeof response.data.phone !== "undefined") {
              $vm.user_form.phone = response.data.phone;
            }
            if (typeof response.data.address !== "undefined") {
              $vm.user_form.address = response.data.address;
            }
            if (typeof response.data.town !== "undefined") {
              $vm.user_form.town = response.data.town;
            }
            if (typeof response.data.sector !== "undefined") {
              $vm.user_form.sector = response.data.sector;
            }
            $vm.isLoading = false
          });
    },
    modify: function () {
      var $vm = this;

      $vm.responseOk = false;
      var user = JSON.parse(JSON.stringify($vm.user_form));

      axios
          .patch(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.user.id,
              user
          )
          .then(function (response) {
            $vm.responseOk = true;
            //$vm.$router.push({name: 'register-success'})
            //var loginData = {username: $vm.user.username, password: $vm.user.plainPassword}
            //axios.post(process.env.VUE_APP_API_BASE_URL+'/api/v1/login', loginData)
            //  .then(function (response) {
            //    $vm.$cookies.set('token', response.data.token)
            //    $vm.$cookies.set('user', response.data.user)
            //    $vm.$router.push({name: 'home'})
            //  })


//  console.log( "VUE_APP_API_BASE_URL"+process.env.VUE_APP_API_BASE_URL )
            axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/user/me')
                .then(function (response) {
                  $vm.$cookies.set('user', response.data)

                  $vm.$toasted.show('Profilo salvato con successo!', {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 1300,
                    type: 'success',
                    class: 'toast'
                  })
                  //ricarico la pagina per far aggiornare il valore del cookie e ricaricare tutti i componenti per leggere
                  //il valore aggiornato dai cookies is_completed
                  location.reload()
                }).catch(error => {
            });

          })
          .catch(function (error) {
            $vm.errors = error.response.data;
          });
    }
  }
};
</script>

<style scoped>
.custom-centered {
  margin: 0 auto;
  width: 300px;
}

.text-color {
  color: white;
}

.ed-bg {
  background-color: #272f44;
  background-color: #222939;
}


.pricing-header {
  color: white;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
